export const emailPlaceholder = {
    us: 'Email',
    eu: 'Email',
    uk: 'Email',
};
